module.exports = __webpack_public_path__ + "img/globe.7591dad5.webp";